import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HomesFacade } from '@library/store/homes/homes.facade';
import { AutoTempModes, CoolingModes, TemperatureControlModes, ThermModes } from '@library/store/homes/homes.interface';
import * as moment from 'moment-timezone';
import { BehaviorSubject, combineLatest, firstValueFrom } from 'rxjs';
import { SidebarControlModeService } from '../../../../sidebar-control-mode.service';

@Component({
  selector: 'app-home-mode-control-validate',
  templateUrl: './home-mode-control-validate.component.html',
  styleUrls: ['./home-mode-control-validate.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeModeControlValidateComponent {
  viewModel$ = combineLatest({
    currentModeEndTime: this.homesFacade.currentModeEndTime$,
    selectedEndDate: this.controlModeService.selectedEndDate$,
    selectedEndTime: this.controlModeService.selectedEndTime$,
    errors: this.controlModeService.dateErrors$
  });

  isLoading$ = new BehaviorSubject(false);

  constructor(
    private controlModeService: SidebarControlModeService,
    private homesFacade: HomesFacade,
  ) {}

  async validate(selectedEndDate: moment.Moment, selectedEndTime: number) {
    const homeId = await firstValueFrom(this.homesFacade.currentHomeId$);
    const temperatureControlMode = await firstValueFrom(this.homesFacade.temperatureControlMode$);

    this.isLoading$.next(true);
    // api needs seconds -> beginning of the selected day + time selected in second
    const endTime = this.momentDateToTimestamp(selectedEndDate, selectedEndTime);

    if (temperatureControlMode === TemperatureControlModes.HEATING) {
      const thermMode = await firstValueFrom(this.homesFacade.thermMode$) as ThermModes;
      await firstValueFrom(this.homesFacade.setHeatingMode(homeId, thermMode, endTime));
    }
    else if (temperatureControlMode === TemperatureControlModes.COOLING) {
      const coolingMode = await firstValueFrom(this.homesFacade.coolingMode$) as CoolingModes;
      await firstValueFrom(this.homesFacade.setCoolingMode(homeId, coolingMode, endTime));
    }
    else if (temperatureControlMode === TemperatureControlModes.AUTO) {
      const autoTempMode = await firstValueFrom(this.homesFacade.autoTempMode$) as AutoTempModes;
      await firstValueFrom(this.homesFacade.setAutoMode(homeId, autoTempMode, endTime));
    }

    this.isLoading$.next(false);
  }

  hasChanged(currentModeEndTime: number, selectedEndDate: moment.Moment, selectedEndTime: number, errors) {
    return !errors && (currentModeEndTime !== this.momentDateToTimestamp(selectedEndDate, selectedEndTime)) ;
  }

  momentDateToTimestamp(endDate: moment.Moment, endTime: number) {
    return endDate?.startOf('day').add(endTime, 'minutes').unix();
  }
}